export const CATEGORIES = [
  "Electronics",
  "Fashion",
  "Grocery",
  "Furniture",
  "Automobile",
  "Services",
  "Others"
];
